export const APPLICATIONID = process.env.VUE_APP_APPLICATIONID;

export const SCOPE = process.env.VUE_APP_SCOPE;
export const RESPONSETYPE = 'token id_token';
export const REDIRECTURI = process.env.VUE_APP_BASE_URL;
export const TENANTNAME = 'LCPB2CDEV.onmicrosoft.com';
export const HELLOJSLOGINNAME = 'b2clogin';
export const EDITPROFILEPOLICYNAME = 'B2C_1_B2C_ProfE';
export const HELLOJSEDITPROFILEPOLICY = 'adB2CEditProfile';
